<template>
  <!-- 第3行 -->
  <div class="three">
    <div class="left" style="flex: 1;">
      <div class="tit">工单类型</div>
      <vchart class="vchart" ref='vchart'></vchart>
    </div>
    <div class="right left" style="flex: 2;">
      <div class="t" style="padding-bottom: 0;">
        <div class="tit">
          <span>工单最新事件</span>
          <div class="line"><router-link to="realOrderList">查看更多</router-link></div>
        </div>
        <div class="box">

          <table class="table" style="width: 100%;" border="0">
            <thead>
              <tr class="tr">
                <td scope="col" style="width:50px" align="center">序号</td>
                <td scope="col">告警单位</td>
                <td scope="col">工单标题</td>
                <td scope="col" align="center">工单类型</td>
                <td scope="col" align="center">工单状态</td>
                <td scope="col" align="center">工单发起时间</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in 5" :key="i" class="tbody">
                <td scope="row" align="center">{{i}}</td>
                <td scope="row" class="pp">山西省电力机车</td>
                <td scope="row" class="pp">配电房</td>
                <td scope="row" align="center">抢修</td>
                <td scope="row" align="center"> <i class="ii"></i> 处理中</td>
                <td scope="row" align="center" style="color: #666;">2024/04/02 12:00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vchart from '../../components/module/Charts/chart.vue';//echart图
  import webMap from "@/page/webMap/webMap.vue";
  import left from "./left.vue";
  import two from "./two.vue";
  export default {
    components: {
      webMap,
      left,
      two,
      vchart
    },
    data () {
      return {
        roundOption: {
          title: {
            text: '2326',
            subtext: '工单数量',
            left: '26%',
            top: '40%',
            textAlign: 'center',
            subtextStyle: {
              color: '#666',
              fontSize: 13,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#000',
            }
          },
          legend: {
            icon: "roundRect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度 
            orient: 'vertical',
            right: '6%',
            top: 'center',
            itemGap: 24,
            formatter: function(name) {
              if(name.length==4) {
                return name+`   367`;
              } else {
                return name+`      36`;
              }

            },
            textStyle: { // 图例的公用文本样式。
              fontSize: 13,
              color: '#000'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)  ({d}%)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: false,
              },
              data: [
                {
                  value: 10,
                  name: '已处理'
                },
                {
                  value: 20,
                  name: '处理中'
                },{
                  value: 20,
                  name: '待处理'
                },{
                  value: 20,
                  name: '验收完成'
                },
              ],
              color: ["#00ac3e","#005dff",'#ccc','#ff9532'],
              radius: ['56%','70%'],
              center: ['27%','50%'],
            }
          ]
        },

        nowScale: 50, //当前缩放倍率
        token: '', //token
        ids: [],
        svgPath: '',
      }
    },

    mounted () {
      this.$refs.vchart.setData(this.roundOption,true);
    },
    destroyed () {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .ii {
    /* 自动布局子元素 */
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #00AC3E;
    margin-right: 2px;
  }

  .box {
    .table {
      flex: 1;
      margin-right: 15px;
    }

    a,
    p,
    label,
    input,
    textarea,
    li,
    u,
    table,
    th {
      background-color: #fff;
    }

    table {
      border-collapse: collapse;
    }

    table {
      border: 1px solid #ebebeb;
    }

    .tbody {
      border-top: 1px solid #ebebeb;

      td {
        padding: 6px;
      }
    }

    .tr {
      background-color: #F7F9FA;

      td {
        padding: 8px;
      }
    }

    .pp {
      padding-left: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 200px;
    }

  }

  .ul {
    display: flex;
    flex-wrap: wrap;

    .li {
      width: calc(50% - 12px);
      margin-right: 12px;
      border-radius: 4px;
      box-sizing: border-box;
      /* 自动布局 */
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 12px 20px;
      background: #F7F9FA;
      margin-bottom: 12px;

      .num {
        /* 自动布局子元素 */
        font-family: Arial;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 2px;
        color: #1A1A1A;
      }

      .name {
        /* 自动布局子元素 */
        font-family: Microsoft YaHei;
        font-size: 13px;
        font-weight: normal;
        line-height: normal;
        color: #666;
        margin-bottom: 10px;
      }

      .percentage {
        /* 自动布局子元素 */
        font-family: Microsoft YaHei;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #FF0000;
        display: flex;
        align-items: center;

        img {
          margin-right: 4px;
        }
      }

      .percentage2 {
        color: #009030;
      }
    }
  }

  .three {
    display: flex;
    margin-top: 12px;

    .box {
      display: flex;
    }

    .left {
      background-color: #fff;
      border-radius: 4px;
      padding-left: 12px;
      overflow: hidden;
    }

    .right {
      margin-left: 12px;
      width: auto;
    }
  }

  .left {
    .t {
      background-color: #fff;
      padding-left: 12px;
      margin-bottom: 12px;
      overflow: hidden;
      border-radius: 4px;
      padding-bottom: 20px;
    }
  }

  .tit {
    height: 18px;
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: bold;
    color: #1A1A1A;
    margin-top: 12px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 20px;

    .line {
      height: 17px;
      font-family: Microsoft YaHei;
      font-size: 13px;
      font-weight: normal;
      color: #666;
      cursor: pointer;

      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }

  .vchart {
    height: 200px;
  }
</style>